import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Typography, Button, Spin } from 'antd';
import date from '../../helpers/date';
import PropTypes from 'prop-types';
import signImage from './../../images/sign-image.svg';

const { Title } = Typography;
const { formatString } = date;

const IntroSign = ({ changeView, contract }) => {

  const [loaderSpinning, setLoaderSpinning] = useState(true);

  useEffect(() => {
    setLoaderSpinning(false);
  }, [contract]);

  const handleChange = () => {
    changeView(1);
  };

  return (
    <Spin
      spinning={loaderSpinning}
    >
      <div className="text-center">
        <Row className="justify-content-center">
          <Col>
            <img src={signImage} className="mb-4" alt="" />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md={12} className="mx-auto">
            <Title level={2}>Revisión y validación de contrato de arriendo</Title>
            <p className="mb-4">Presiona el botón “revisar contrato” y podrás aprobar el contrato de arriendo a través del dibujo de tu firma.
              Creador <b>{contract.arrendador.nombre} {contract.arrendador.apellido} {contract.arrendador.segundoApellido}</b>, inmueble ubicado en <b>{contract.inmueble && contract.inmueble.direccion}, {contract.inmueble && contract.inmueble.comuna}</b>, con fecha de emisión <b>{formatString(contract.fecha)}.</b></p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mx-auto">
            <Button className="px-4" size="large" type="primary" onClick={handleChange}>Revisar Contrato</Button>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

IntroSign.propTypes = {
  changeView: PropTypes.func.isRequired,
  contract: PropTypes.object.isRequired,
};

const data = (state) => ({
  contract: state.contract.contract,
});

export default connect(data, null)(IntroSign);